import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const AudioVideoIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-audioVideo"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M47,4 L21,4 C18.7907153,4 17,5.79071525 17,8 L17,26 C17,28.2092847 18.7907153,30 21,30 L47,30 C49.2092847,30 51,28.2092847 51,26 L51,8 C51,5.79071525 49.2092847,4 47,4 Z M21,6 L47,6 C48.1047153,6 49,6.89528475 49,8 L49,26 C49,27.1047153 48.1047153,28 47,28 L21,28 C19.8952847,28 19,27.1047153 19,26 L19,8 C19,6.89528475 19.8952847,6 21,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M46.5,7 L21.5,7 C20.6718576,7 20,7.67185763 20,8.5 L20,25.5 C20,26.3281424 20.6718576,27 21.5,27 L46.5,27 C47.3281424,27 48,26.3281424 48,25.5 L48,8.5 C48,7.67185763 47.3281424,7 46.5,7 Z M21.5,8 L46.5,8 C46.7758576,8 47,8.22414237 47,8.5 L47,25.5 C47,25.7758576 46.7758576,26 46.5,26 L21.5,26 C21.2241424,26 21,25.7758576 21,25.5 L21,8.5 C21,8.22414237 21.2241424,8 21.5,8 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M9.7071,24.2929 C7.5241,22.4579 6.0001,19.9109 6.0001,16.9999 C6.0001,14.0889 7.5241,11.5429 9.7071,9.7069 C10.6931,8.8779 9.2721,7.4689 8.2931,8.2929 C5.7201,10.4569 4.0001,13.5929 4.0001,16.9999 C4.0001,20.4069 5.7201,23.5429 8.2931,25.7069 C9.2721,26.5309 10.6941,25.1229 9.7071,24.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M11.7071 20.2929C11.1221 19.7989 10.7261 19.3459 10.3881 18.6729 10.1391 18.1769 10.0001 17.5659 10.0001 16.9999 10.0001 16.8449 10.0091 16.6899 10.0231 16.5349 10.0311 16.4639 10.0301 16.4659 10.0201 16.5439 10.0251 16.5089 10.0311 16.4749 10.0371 16.4409 10.0541 16.3559 10.0701 16.2699 10.0891 16.1859 10.1681 15.8469 10.2571 15.5939 10.3631 15.3759 10.7041 14.6799 11.1081 14.2129 11.7071 13.7069 12.1201 13.3589 12.0661 12.6519 11.7071 12.2929 11.2981 11.8839 10.7071 11.9429 10.2931 12.2929 8.9111 13.4599 8.0001 15.1699 8.0001 16.9999 8.0001 18.8299 8.9111 20.5399 10.2931 21.7069 10.7051 22.0549 11.3031 22.1119 11.7071 21.7069 12.0641 21.3499 12.1221 20.6429 11.7071 20.2929M59.7071 25.7071C62.2801 23.5431 64.0001 20.4071 64.0001 17.0001 64.0001 13.5931 62.2801 10.4571 59.7071 8.2931 58.7281 7.4691 57.3061 8.8771 58.2931 9.7071 60.4751 11.5421 62.0001 14.0891 62.0001 17.0001 62.0001 19.9111 60.4751 22.4571 58.2931 24.2931 57.3071 25.1221 58.7281 26.5311 59.7071 25.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M57.7071 21.7071C59.0891 20.5401 60.0001 18.8301 60.0001 17.0001 60.0001 15.1701 59.0891 13.4601 57.7071 12.2931 57.2951 11.9451 56.6971 11.8881 56.2931 12.2931 55.9351 12.6501 55.8781 13.3571 56.2931 13.7071 56.8781 14.2011 57.2731 14.6541 57.6121 15.3271 57.8611 15.8231 58.0001 16.4341 58.0001 17.0001 58.0001 17.1551 57.9901 17.3101 57.9771 17.4651 57.9691 17.5361 57.9701 17.5341 57.9801 17.4561L57.9631 17.5591C57.9461 17.6441 57.9301 17.7301 57.9101 17.8141 57.8311 18.1531 57.7431 18.4061 57.6361 18.6241 57.2961 19.3201 56.8921 19.7871 56.2931 20.2931 55.8801 20.6411 55.9341 21.3481 56.2931 21.7071 56.7021 22.1161 57.2931 22.0571 57.7071 21.7071M37.604 16.2741C38.132 16.6131 38.132 17.3871 37.604 17.7261L34.367 19.8061 31.13 21.8861C30.628 22.2091 30 21.8061 30 21.1601L30 17.0001 30 12.8391C30 12.1941 30.628 11.7911 31.13 12.1131L34.367 14.1941 37.604 16.2741Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
